// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__AddIncidentFormComponent__no-label-top-spacing{padding-top:12px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-quoteandbind-pup-react/components/AddIncidentFormComponent/AddIncidentFormComponent.module.scss"],"names":[],"mappings":"AAAA,qDACI,gBAAA","sourcesContent":[".no-label-top-spacing {\n    padding-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-label-top-spacing": "app__AddIncidentFormComponent__no-label-top-spacing"
};
export default ___CSS_LOADER_EXPORT___;
